// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import { MrCard } from '@ion/components';
import React, { useEffect } from 'react';
import pt from 'prop-types';
import IntegrationTableTitle from '../../integration-table-title/IntegrationTableTitle';
import styles from '../../index.module.scss';
import GoogleTagParentBody from './GoogleTagParentBody';
import { useConsentCategoriesContext } from '@ion/app/src/context/consent-categories-context';

const GoogleTagParentContainer = ({
  stagedSyncs,
  setField,
  validateField,
  validateNumber,
  validateRequired,
  formState,
  resetError,
  setModalOpen,
}) => {
  const onClickGoogleTagDelete = () => {
    setModalOpen({ data: stagedSyncs, type: 'Identity Sync', name: 'googleGtag' });
  };

  const onClickSyncDelete = sync => {
    setModalOpen({ data: sync, type: 'Identity Sync', name: sync.name });
  };
  const { consentCategories } = useConsentCategoriesContext();

  useEffect(() => {
    if (!consentCategories || consentCategories.length === 0) return;

    const findCategoryIdByCodes = codes => {
      const desired = new Set(codes.map(c => String(c).toLowerCase()));
      const match = consentCategories.find(cat => desired.has(String(cat.code).toLowerCase()));
      return match?.id;
    };

    const CONSENT_FIELD_CONFIGS = [
      {
        field: 'sync-googleAnalytics4-consentCategoryId',
        codes: ['C0002', 'analytics', 'performance'],
      },
      {
        field: 'sync-CM360-consentCategoryId',
        codes: ['C0004', 'targeting', 'advertising'],
      },
      {
        field: 'sync-googleAds-consentCategoryId',
        codes: ['C0004', 'targeting', 'advertising'],
      },
    ];

    CONSENT_FIELD_CONFIGS.forEach(({ field, codes }) => {
      if (!formState[field]) {
        const id = findCategoryIdByCodes(codes);
        if (id) {
          setField({ target: { name: field, value: id } });
        }
      }
    });
  }, [consentCategories]);

  return (
    <MrCard
      className={styles.builderCard}
      top={
        <IntegrationTableTitle
          logoName={'googleGtag'}
          title={'Google Tag Settings'}
          onClickDelete={onClickGoogleTagDelete}
          deleteTitle='"Remove Google Tag"'
        />
      }
      bottom={
        <GoogleTagParentBody
          setField={setField}
          validateField={validateField}
          validateNumber={validateNumber}
          validateRequired={validateRequired}
          formState={formState}
          resetError={resetError}
          stagedSyncs={stagedSyncs}
          onClickSyncDelete={onClickSyncDelete}
        />
      }
    />
  );
};

GoogleTagParentContainer.propTypes = {
  formState: pt.object,
  resetError: pt.func,
  setField: pt.func,
  setModalOpen: pt.func,
  stagedSyncs: pt.array,
  validateField: pt.func,
  validateNumber: pt.func,
  validateRequired: pt.func,
};

export default GoogleTagParentContainer;
